import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Inject
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  catchError,
  finalize,
  map,
  tap,
  takeUntil,
  debounceTime,
  filter,
  distinctUntilChanged
} from 'rxjs/operators';
import { AllocationAndReceivingRunningBalanceService } from '../allocation-and-receiving-running-balance.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger
} from '@angular/material/autocomplete';
import { LanguageService, DialogService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { MediaObserver } from '@angular/flex-layout';
import { of as observableOf, fromEvent } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'esc-allocation-and-receiving-running-balance-filter',
  templateUrl:
    './allocation-and-receiving-running-balance-filter.component.html',
  styleUrls: [
    './allocation-and-receiving-running-balance-filter.component.scss'
  ]
})
export class AllocationAndReceivingRunningBalanceFilterComponent
  implements OnInit
{
  @Output() generateReport = new EventEmitter();

  @ViewChild('levelAC') levelACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) levelACTr: MatAutocompleteTrigger;

  @ViewChild('campaignAC') campaignACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) campaignACTr: MatAutocompleteTrigger;

  @ViewChild('distributionAC') distributionACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) distributionACTr: MatAutocompleteTrigger;

  constructor(
    @Inject(MAT_DIALOG_DATA) public initialFilters,
    private dialogRef: MatDialogRef<AllocationAndReceivingRunningBalanceFilterComponent>,
    private fb: FormBuilder,
    public media: MediaObserver,
    public service: AllocationAndReceivingRunningBalanceService,
    private dialogService: DialogService,
    private languageService: LanguageService
  ) {}

  public defaultOption = {
    code: 'all',
    description: 'All'
  };
  public loading = {
    campaign: false,
    distribution: false,
    level: false,
    error: false
  };

  campaigns = [];
  distributions = [];
  data;

  levels = [
    { id: 1, description: 'Level 1' },
    { id: 2, description: 'Level 2' }
  ];

  public filters;
  public formGroup: FormGroup;
  networkErrMsg = this.languageService.getTranslation(
    'MESSAGE_ERROR_NETWORK_CONNECTION',
    {}
  );

  ngOnInit() {
    this.initForm();
    this.detectFormChanges();
  }

  initForm() {
    this.campaigns = this.initialFilters.campaigns;
    this.distributions = this.initialFilters.distributions;
    const selectedLevel = this.levels.find(
      (level) => level.id === this.initialFilters.filters.web_filter.level
    );
    const selectedCampaign = this.campaigns.find(
      (campaign) =>
        campaign.id === this.initialFilters.filters.web_filter.campaign_id
    );
    const selectedDistribution = this.distributions.find(
      (distribution) =>
        distribution.id === this.initialFilters.filters.web_filter.distribution_id
    );

    console.log(selectedLevel, selectedCampaign, selectedDistribution);

    this.formGroup = this.fb.group({
      level: [selectedLevel, Validators.required],
      campaign: [selectedCampaign, Validators.required],
      distribution: [selectedDistribution, Validators.required]
    });
  }

  detectFormChanges() {
    this.formGroup.get('level')
      .valueChanges
      .subscribe((value) => {
      this.formGroup.get('campaign').setValue(null, { emitEvent: false });
      this.formGroup.get('distribution').setValue(null, { emitEvent: false });
    });

    this.formGroup
      .get('campaign')
      .valueChanges
      .subscribe((value) => {
        this.formGroup.get('distribution').setValue(null, { emitEvent: false });
        this.filters.web_filter.keyword = _.toString(value);
        this.campaigns = [];
        this.getData('campaign');
      });

    this.formGroup
      .get('distribution')
      .valueChanges
      .subscribe((value) => {
        this.filters.web_filter.keyword = _.toString(value);
        this.distributions = [];
        this.getData('distribution');
      });
  }

  getInitialData(name) {
    this.autoCmpltClosed(name);
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.getData(name);
  }

  getMoreData(name) {
    if (this.filters.getMore) {
      this.filters.web_filter.offset += INITIAL_OPTIONS.web_filter.limit;
      this.getData(name);
    }
  }

  getData(name) {
    let filters = _.cloneDeep(this.filters);
    this.filters.getMore = false;
    this.loading[name] = true;

    switch (name) {
      case 'campaign': {
        this.campaigns = [];
        filters.web_filter['level'] =
          _.get(this.formGroup.get('level'), 'value.id') || 0;
        filters.web_filter['filter_type'] = 'campaign';
        // filters.web_filter.filters["campaign_id"] = 0;
        // filters.web_filter.filters["distribution_id"] = 0;

        this.service
          .filter(filters)
          .pipe(
            tap(() => (this.loading.campaign = true)),
            finalize(() => {
              this.loading.campaign = false;
              return observableOf(null);
            }),
            catchError((err) => {
              console.error(err);
              this.loading.campaign = false;
              return observableOf(null);
            })
          )
          .subscribe((res: any) => {
            this.loading.campaign = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (
              res == null ||
              res.status == 0 ||
              res.status == 504 ||
              res.status == 500
            ) {
              this.loading.error = true;
              this.campaigns = [];
              this.dialogService.openSnackBar(this.networkErrMsg);
              return;
            }
            if (_.has(res, 'value') && res.value == 'Success') {
              this.campaigns = this.campaigns.concat(res.data);

              if (
                res.data.length > 0 &&
                this.campaigns.length < _.get(res, 'count')
              ) {
                this.filters.getMore = true;
              }
            }
          });
        break;
      }

      case 'distribution': {
        this.distributions = [];
        filters.web_filter['level'] =
          _.get(this.formGroup.get('level'), 'value.id') || 0;
        filters.web_filter['filter_type'] = 'distribution';
        filters.web_filter.filters['campaign_id'] =
          _.get(this.formGroup.get('campaign'), 'value.id') || 0;
        filters.web_filter.filters['distribution_id'] = 0;

        this.service
          .filter(filters)
          .pipe(
            tap(() => (this.loading.distribution = true)),
            finalize(() => {
              this.loading.distribution = false;
              return observableOf(null);
            }),
            catchError((err) => {
              console.error(err);
              this.loading.distribution = false;
              return observableOf(null);
            })
          )
          .subscribe((res: any) => {
            this.loading.distribution = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (
              res == null ||
              res.status == 0 ||
              res.status == 504 ||
              res.status == 500
            ) {
              this.loading.error = true;
              this.distributions = [];
              this.dialogService.openSnackBar(this.networkErrMsg);
              return;
            }
            if (_.has(res, 'value') && res.value == 'Success') {
              this.distributions = this.distributions.concat(res.data);

              if (
                res.data.length > 0 &&
                this.distributions.length < _.get(res, 'count')
              ) {
                this.filters.getMore = true;
              }
            }
          });
        break;
      }
    }
  }

  autoCmpltClosed(option) {
    this[option] = [];
  }

  resetControl(control: FormControl) {
    control.reset(null, { emitEvent: false });
  }

  displayFn(data?: any): string | undefined {
    return data ? _.get(data, 'description') : null;
  }

  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map((x) => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe((x) => {
            const scrollTop = this[refName].panel.nativeElement.scrollTop;
            const scrollHeight = this[refName].panel.nativeElement.scrollHeight;
            const elementHeight =
              this[refName].panel.nativeElement.clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              // fetch more data
              this.getMoreData(name);
            }
          });
      }
    });
  }

  applyFilters() {
    for (let ctrl in this.formGroup.controls) {
      if (!this.formGroup.controls[ctrl].valid) {
        this.formGroup.controls[ctrl].markAsTouched();
      }
    }

    if (this.formGroup.valid) {
      this.dialogRef.close({
        level: this.formGroup.controls.level.value.id,
        campaign_id: this.formGroup.controls.campaign.value.id,
        distribution_id: this.formGroup.controls.distribution.value.id
      });
    }
  }

  checkAutocompleteObject(control, objectKey, targetArray) {
    if (
      (!_.isObject(control.controls[objectKey].value) ||
        control.controls[objectKey].value.id == null) &&
      control.controls[objectKey].value != ''
    ) {
      control.controls[objectKey].setErrors({
        notExisting: true
      });
    }

    if (_.size(this[targetArray]) && targetArray) {
      control.controls[objectKey].setValue(null);
      this.assignFormValues(targetArray, objectKey);
    }
  }

  enableCheckbox(optionArray) {
    optionArray.forEach((e) => {
      e.disabled = false;
    });
  }

  disableCheckbox(optionArray, formControlName, data) {
    if (
      (optionArray[0].selected &&
        _.has(this.formGroup.get(formControlName), 'value') &&
        this.formGroup.get(formControlName).value == 0) ||
      _.get(data, 'code') == 'all'
    ) {
      optionArray.forEach((e) => {
        if (e.code != 'all') {
          e.disabled = true;
        }
      });
    } else {
      this.enableCheckbox(optionArray);
    }
  }

  assignFormValues(targetArray, formControlName) {
    let tempArr;

    this.formGroup.get(formControlName).setValue(tempArr);
  }

  reset() {
    for (let ctrl in this.formGroup.controls) {
      this.formGroup.controls[ctrl].reset(null, { emitEvent: false });
      this.formGroup.controls[ctrl].setValue(null, { emitEvent: false });
      this.formGroup.controls[ctrl].markAsUntouched();
    }
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    level: 999,
    filter_type: '',
    filters: {
      campaign_id: 0,
      distribution_id: 0
    },
    limit: 50,
    offset: 0,
    keyword: ''
  }
};
